<template>
  <!-- Sign In/Sign Up/Password Reset forms -->
  <!-- TODO: mode does not using and shoulbe removed from this code -->
  <div>
    <!-- Account Link Warning -->

    <!-- Gate Mode Overlay with Logo and Text - now at top level -->
    <div v-if="shouldDisplayForms && !signedIn" class="gate-overlay">
      <!-- Logo and Text temporary disabled -->
      <div v-if="false" class="gate-overlay-content">
        <AppLogo :online="false" />
        <h2 class="mt-3">Что приготовить сегодня?</h2>
      </div>
    </div>

    <!-- Sign In/Sign Up/Password Reset forms -->
    <div v-if="!signedIn" class="login-page">
      <!--  Container with Sign In and Sign Up forms       -->
      <div class="container">
        <!-- Sign In -->
        <div
          v-if="authFormType == SIGNIN_FORM"
          class="card login"
          v-bind:class="{ error: emptyFields }"
        >
          <h2>Вход</h2>
          <form class="form-group" action="javascript:void(0);">
            <!-- Login key input group -->
            <input
              v-model="emailLogin"
              type="email"
              class="form-control mb-3"
              placeholder="Email"
              required
            />

            <!-- Password input group -->
            <div class="input-group mb-3">
              <input
                v-model="passwordLogin"
                :type="passwordFieldType"
                class="form-control"
                placeholder="Пароль"
                autocomplete="on"
                required
              />
              <button
                class="btn btn-outline-secondary"
                type="button"
                @click="togglePasswordVisibility"
              >
                <i
                  :class="
                    passwordFieldType === 'password'
                      ? 'bi bi-eye-slash'
                      : 'bi bi-eye'
                  "
                ></i>
              </button>
            </div>

            <!-- Login button -->
            <input
              type="submit"
              class="btn btn-outline-success me-2 mb-3"
              @click="doLogin"
              value="Войти"
            />

            <!-- Provider Login buttons -->
            <div class="mb-4">
              <input
                type="button"
                class="btn btn-outline-info me-2"
                @click="doLoginGoogle"
                value="Google"
              />
              <input
                type="button"
                class="btn btn-outline-danger me-2"
                @click="doLoginYandex()"
                value="Яндекс"
              />
              <input
                type="button"
                class="btn btn-outline-primary"
                @click="doLoginTelegram"
                value="Telegram"
              />
            </div>

            <!-- "Don't have an account?" and "Forgot password?" always visible in forms -->
            <p>
              Нет аккаунта?
              <a
                href="javascript:void(0);"
                @click="
                  (authFormType = SIGNUP_FORM),
                    ((emptyFields = false), (errMsg = ''))
                "
                >Зарегистрируйтесь</a
              >
            </p>

            <!-- Show "Login without registration" only in gate mode -->
            <p v-if="mode === 'profile'">
              <a href="javascript:void(0);" @click="doAnonymousLogin"
                >Войти без регистрации</a
              >
            </p>

            <!-- Forgot password? -->
            <p>
              <a
                href="javascript:void(0);"
                @click="
                  (authFormType = RESET_PASSWORD_FORM),
                    ((emptyFields = false), (errMsg = ''))
                "
                >Забыли пароль?</a
              >
            </p>
          </form>
        </div>

        <!-- Sign Up -->
        <div
          v-if="authFormType == SIGNUP_FORM"
          class="card register"
          v-bind:class="{ error: emptyFields }"
        >
          <h2>Регистрация</h2>
          <form class="form-group" action="javascript:void(0);">
            <!-- Email input group -->
            <input
              v-model="emailReg"
              type="email"
              class="form-control mb-3"
              placeholder="Email"
              required
            />

            <!-- Password input group -->
            <div class="input-group">
              <input
                v-model="passwordReg"
                :type="passwordFieldType"
                class="form-control mb-3"
                placeholder="Пароль"
                autocomplete="on"
                required
              />
              <button
                class="btn btn-outline-secondary mb-3"
                type="button"
                @click="togglePasswordVisibility"
              >
                <i
                  :class="
                    passwordFieldType === 'password'
                      ? 'bi bi-eye-slash'
                      : 'bi bi-eye'
                  "
                ></i>
              </button>
            </div>
            <input
              v-model="confirmReg"
              :type="passwordFieldType"
              class="form-control mb-3"
              placeholder="Подтвердите пароль"
              autocomplete="on"
              required
            />
            <input
              type="submit"
              class="btn btn-outline-success mb-3"
              @click="doRegister"
              value="Зарегистрироваться"
            />
            <p class="mt-2">
              Уже есть аккаунт?
              <a
                href="javascript:void(0);"
                @click="
                  (authFormType = SIGNIN_FORM),
                    ((emptyFields = false), (errMsg = ''))
                "
                >Войдите</a
              >
            </p>
          </form>
        </div>

        <!-- Email Verify -->
        <div
          v-if="authFormType == VERIFY_FORM"
          class="card verify"
          v-bind:class="{ error: emptyFields }"
        >
          <h2>Подтверждение адреса электронной почты</h2>
          <form class="form-group" action="javascript:void(0);">
            <p>
              Пожалуйста, проверьте свою электронную почту и перейдите по ссылке
              для подтверждения.<br />
              <br />
              Затем
              <a
                href="javascript:void(0);"
                @click="
                  (authFormType = SIGNIN_FORM),
                    ((emptyFields = false), (errMsg = ''))
                "
                >войдите здесь</a
              >
            </p>
          </form>
        </div>

        <!-- Password reset email -->
        <div
          v-if="authFormType == RESET_PASSWORD_FORM"
          class="card login"
          v-bind:class="{ error: emptyFields }"
        >
          <h2>Сброс пароля</h2>
          <form class="form-group" action="javascript:void(0);">
            <input
              v-model="emailReset"
              type="email"
              class="form-control mb-3"
              placeholder="Email"
              required
            />
            <input
              type="submit"
              class="btn btn-outline-success mb-3"
              @click="doResetPassword"
              value="Отправить"
            />
            <p>
              Чтобы сбросить пароль, введите адрес электронной почты и нажмите
              кнопку "Отправить". Проверьте свою почту и следуйте инструкциям в
              письме.<br />
              <br />
              <br />
              Затем
              <a
                href="javascript:void(0);"
                @click="
                  (authFormType = SIGNIN_FORM),
                    ((emptyFields = false), (errMsg = ''))
                "
                >войдите здесь</a
              >
            </p>
          </form>
        </div>

        <div class="card errmsg" v-if="errMsg">{{ errMsg }}</div>
      </div>
    </div>

    <!-- Sign Out Button and link to account management -->
    <div
      v-if="signedIn && showButton"
      class="btn-group login-signout-container float-end"
      role="group"
    >
      <!-- Sign Out Button -->
      <button
        class="btn btn-outline-success btn-sm"
        type="button"
        @click="doLogout()"
      >
        <img
          v-if="user && user.photoURL"
          :src="user.photoURL"
          class="img-thumbnail me-2"
          alt="User Avatar"
        />
        Выйти
      </button>

      <!-- Account Management Dropdown Toggle -->
      <button
        type="button"
        class="btn btn-outline-success btn-sm dropdown-toggle dropdown-toggle-split"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        title="Управление аккаунтом"
      >
        <span class="visually-hidden">Управление аккаунтом</span>
      </button>

      <!-- Account Management Dropdown Menu -->
      <ul class="dropdown-menu dropdown-menu-end">
        <li v-if="!isGoogleLinked || !isYandexLinked">
          <h6 class="dropdown-header">Привязать аккаунт</h6>
        </li>
        <li v-if="!isGoogleLinked">
          <a class="dropdown-item" href="#" @click.prevent="linkWithGoogle">
            <i class="bi bi-google me-2"></i>Google
          </a>
        </li>
        <li v-if="!isYandexLinked">
          <a class="dropdown-item" href="#" @click.prevent="linkWithYandex">
            <i class="bi bi-browser-chrome me-2"></i>Yandex
          </a>
        </li>
        <li v-if="!isTelegramLinked">
          <a class="dropdown-item" href="#" @click.prevent="linkWithTelegram">
            <i class="bi bi-telegram me-2"></i>Telegram
          </a>
        </li>
        <!-- TODO: Add email/password linking form -->
        <!-- <li v-if="!isEmailLinked">
          <a class="dropdown-item" href="#" @click.prevent="linkWithEmail">
            <i class="bi bi-envelope-at me-2"></i>Email/Пароль
          </a>
        </li> -->
      </ul>
    </div>

    <!-- Firebase Processing Overlay -->
    <div v-if="isFirebaseProcessing" class="firebase-processing-overlay">
      <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">Загрузка...</span>
      </div>
      <p class="mt-2 text-light">Проверка авторизации...</p>
    </div>

    <!-- Global error message for signed-in state -->
    <div v-if="signedIn && errMsg" class="container fixed-top-alert">
      <div class="alert alert-danger alert-dismissible fade show" role="alert">
        {{ errMsg }}
        <button
          type="button"
          class="btn-close"
          @click="errMsg = ''"
          aria-label="Close"
        ></button>
      </div>
    </div>

    <!-- Global success message for signed-in state -->
    <div v-if="signedIn && successMsg" class="container fixed-top-alert">
      <div class="alert alert-success alert-dismissible fade show" role="alert">
        {{ successMsg }}
        <button
          type="button"
          class="btn-close"
          @click="successMsg = ''"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
const cmdCheckToken = "auth.checktoken";
const cmdAccessAdmin = "login.access-admin";
const cmdAccessDevel = "login.access-devel";

const tokensStorageField = "cooksy_tokens";
const activeLoginField = "cooksy_active_login";

import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  getAuth,
  signOut,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { logEvent } from "@/services/analytics.js";
import AppLogo from "./AppLogo.vue";

export default {
  name: "SignIn",

  created() {
    this.SIGNIN_FORM = 0;
    this.SIGNUP_FORM = 1;
    this.VERIFY_FORM = 2;
    this.TOKEN_TYPE_FIREBASE = "firebase";
    this.TOKEN_TYPE_AUTOLOGIN = "auto-login";
    this.RESET_PASSWORD_FORM = 3;
  },

  components: {
    AppLogo,
  },

  props: {
    needLogout: Boolean,
    showButton: Boolean,
  },

  data() {
    return {
      mode: "profile",

      reader: null,

      /**
       * Current auth form to display
       * 0 - sign in
       * 1 - sign up
       * 2 - verify email
       * 3 - reset password
       * @type {Number}
       */
      authFormType: 0,

      /**
       * Email for login
       * @type {String}
       */
      emailLogin: "",

      /**
       * Password for login
       * @type {String}
       */
      passwordLogin: "",

      /**
       * Email for registration
       * @type {String}
       */
      emailReg: "",

      /**
       * Password for registration
       * @type {String}
       */
      passwordReg: "",

      /**
       * Password input type (text or password)
       * @type {String}
       */
      passwordFieldType: "password",

      /**
       * Confirm registration email
       * @type {String}
       */
      confirmReg: "",

      /**
       * Email for password reset
       * @type {String}
       */
      emailReset: "",

      /**
       * Are there empty fields in the form
       * @type {Boolean}
       */
      emptyFields: false,

      /**
       * Error message to display
       * @type {String}
       */
      errMsg: "",

      /**
       * Success message to display
       * @type {String}
       */
      successMsg: "",

      /**
       * Firebase auth instance
       * @type {Object}
       */
      auth: null,

      /**
       * Sign in state
       * @type {Boolean}
       */
      signedIn: true,

      /**
       * User data from Firebase
       * @type {Object}
       */
      user: null,

      /**
       * Should display sign in/sign up forms
       * @type {Boolean}
       */
      shouldDisplayForms: true,

      /**
       * Timer for periodic checkToken command
       * @type {Number}
       */
      checkTokenTimeoutId: null,

      /**
       * Is Firebase processing an auth request
       * @type {Boolean}
       */
      isFirebaseProcessing: false,

      /**
       * Timer for hiding the Firebase processing overlay
       * @type {Number}
       */
      hideProcessingOverlayTimeoutId: null,
      /**
       * Flag to indicate if the initial check of IndexedDB found it empty or errored.
       * @type {Boolean}
       */
      initialIndexedDBStateKnown: false,
      /**
       * Unsubscribe function for onAuthStateChanged.
       * @type {Function|null}
       */
      authUnsubscribe: null,
      /**
       * A list of auth providers linked to the current user account from the backend.
       * @type {Array<string>}
       */
      linkedProviders: [],
      isLinking: false, // Flag to manage account linking flow
      /**
       * Telegram Main Button instance.
       * @type {Object|null}
       */
      tgMainButton: null,
      /**
       * Telegram Back Button instance.
       * @type {Object|null}
       */
      tgBackButton: null,
      /**
       * Telegram Haptic Feedback instance.
       * @type {Object|null}
       */
      tgHapticFeedback: null,
    };
  },

  computed: {
    // Check if a Google account is linked via Firebase user object.
    isGoogleLinked() {
      return this.linkedProviders.includes("firebase");
    },
    // Check if a Yandex account is the currently active login method.
    // This is a temporary check. A full solution would query the backend
    // for all linked providers.
    isYandexLinked() {
      return this.linkedProviders.includes("yandex");
    },

    // Check if a Telegram account is the currently active login method.
    // This is a temporary check. A full solution would query the backend
    // for all linked providers.
    isTelegramLinked() {
      return this.linkedProviders.includes("telegram");
    },

    // A simple check for anonymous login.
    isAnonymous() {
      return this.getActiveLogin() === "autologin";
    },
  },

  mounted: function () {
    const that = this;

    // Wait for the connection to be established, then initialize authentication.
    this.whenConnected(() => {
      that.authInit();
      that.syncTelegramTheme();
      that.setupTelegramControls();
      // The Telegram widget is no longer used, so setupTelegramLogin is removed.
    });
  },

  unmounted: function () {
    this.teoweb.delReader(this.reader);
    if (this.authUnsubscribe) {
      this.authUnsubscribe();
    }
    if (this.tgMainButton) {
      this.tgMainButton.offClick(this.doAnonymousLogin);
    }
  },

  watch: {
    needLogout: function (val) {
      if (val) {
        this.doLogout();
      }
    },

    signedIn(isNowSignedIn) {
      if (!this.tgMainButton) {
        return;
      }
      if (isNowSignedIn) {
        // User is now signed in, hide the main button.
        this.tgMainButton.hide();
        this.tgMainButton.offClick(this.doAnonymousLogin);
      } else {
        // User is not signed in, show the main button for anonymous login.
        this.tgMainButton.setText("Войти без регистрации");
        this.tgMainButton.onClick(this.doAnonymousLogin);
        this.tgMainButton.show();
      }
    },
  },

  methods: {
    // --- Token Management Helpers ---
    getTokens() {
      try {
        return JSON.parse(localStorage.getItem(tokensStorageField)) || {};
      } catch (e) {
        console.error("Error parsing tokens from localStorage", e);
        return {};
      }
    },
    saveTokens(tokens) {
      localStorage.setItem(tokensStorageField, JSON.stringify(tokens));
    },
    getActiveLogin() {
      return localStorage.getItem(activeLoginField);
    },
    setActiveLogin(type) {
      localStorage.setItem(activeLoginField, type);
    },
    clearActiveLogin() {
      localStorage.removeItem(activeLoginField);
    },

    // --- Core Logic ---

    /**
     * Initializes Telegram Mini App controls like the Main Button.
     */
    setupTelegramControls() {
      if (window.Telegram && window.Telegram.WebApp) {
        const webApp = window.Telegram.WebApp;
        this.tgMainButton = webApp.MainButton;
        this.tgHapticFeedback = webApp.HapticFeedback;

        // Initial setup based on current signedIn state
        if (!this.signedIn) {
          this.tgMainButton.setText("Войти без регистрации");
          this.tgMainButton.onClick(this.doAnonymousLogin);
          this.tgMainButton.show();
        }
      }
    },

    /**
     * Synchronizes the app's theme with the Telegram client's theme.
     * This function checks for the Telegram WebApp object and applies theme
     * colors as CSS variables to the root element, making the app feel native.
     */
    syncTelegramTheme() {
      // The Telegram WebApp object is only available when the app is opened
      // inside Telegram.
      if (window.Telegram && window.Telegram.WebApp) {
        const webApp = window.Telegram.WebApp;
        console.log("Syncing with Telegram theme:", webApp.themeParams);

        // Apply theme colors to CSS variables
        const root = document.documentElement;
        if (webApp.themeParams.bg_color) {
          root.style.setProperty("--bs-body-bg", webApp.themeParams.bg_color);
        }
        if (webApp.themeParams.text_color) {
          root.style.setProperty(
            "--bs-body-color",
            webApp.themeParams.text_color
          );
        }
        if (webApp.themeParams.button_color) {
          root.style.setProperty(
            "--bs-primary",
            webApp.themeParams.button_color
          );
          root.style.setProperty(
            "--bs-primary-rgb",
            this.hexToRgb(webApp.themeParams.button_color)
          );
        }
      }
    },

    /**
     * Hide the Firebase processing overlay with an optional delay.
     * @param {Number} [delay=0] - The delay in milliseconds before hiding the overlay.
     */
    hideProcessingOverlay(delay = 0) {
      // Clear check tocken timeout
      this.clearCheckTokenTimeout();

      // Clear any *previous* hide overlay timeout to prevent multiple scheduled hides
      if (this.hideProcessingOverlayTimeoutId) {
        clearTimeout(this.hideProcessingOverlayTimeoutId);
        this.hideProcessingOverlayTimeoutId = null;
      }

      // Set a new timeout to hide the overlay with the specified delay
      this.hideProcessingOverlayTimeoutId = setTimeout(() => {
        this.isFirebaseProcessing = false;
        this.hideProcessingOverlayTimeoutId = null; // Nullify after execution
      }, delay);
    },

    // Clear check tocken timeout
    clearCheckTokenTimeout: function () {
      if (this.checkTokenTimeoutId) {
        clearTimeout(this.checkTokenTimeoutId);
        this.checkTokenTimeoutId = null;
      }
    },

    /**
     * Return a friendly error message based on the Firebase error code.
     * @param {String} errorCode - The Firebase error code.
     * @param {String} originalMessage - The original error message from Firebase.
     * @returns {String} A friendly error message.
     */
    getFriendlyErrorMessage(errorCode, originalMessage) {
      switch (errorCode) {
        // Invalid email address
        case "auth/invalid-email":
          return "Неверный формат адреса электронной почты.";
        // Firebase v9+ uses auth/invalid-credential for both user-not-found and wrong-password
        case "auth/invalid-credential":
          return "Неверный адрес электронной почты или пароль. Пожалуйста, проверьте введенные данные.";
        // Email address already in use
        case "auth/email-already-in-use":
          return "Этот адрес электронной почты уже используется другим пользователем.";
        // Weak password
        case "auth/weak-password":
          return "Пароль слишком слабый. Используйте не менее 6 символов.";
        // Requires recent login
        case "auth/requires-recent-login":
          return "Это действие требует недавней аутентификации. Пожалуйста, войдите снова.";
        // Too many requests
        case "auth/too-many-requests":
          return "Слишком много попыток. Пожалуйста, попробуйте позже.";
        case "auth/missing-email":
          return "Пожалуйста, введите адрес электронной почты.";
        case "auth/missing-password":
          return "Пожалуйста, введите пароль.";
        // Popup closed by user
        case "auth/popup-closed-by-user":
          return "";
        default:
          console.warn(
            "Неизвестный код ошибки Firebase:",
            errorCode,
            originalMessage
          );
          return (
            "Произошла ошибка. Пожалуйста, попробуйте еще раз. (" + // An error occurred. Please try again.
            errorCode +
            ")"
          );
      }
    },

    /**
     * Initializes Firebase Auth and the user state.
     *
     * This method initializes the Firebase app, gets the Firebase Auth client,
     * and adds the authentication commands to the command processor. It also
     * captures the 'this' for use in closures like the readerlet and sets
     * isFirebaseProcessing to true to show the overlay.
     *
     * @returns {void}
     */
    authInit() {
      const that = this;

      // 1. Initialize Firebase Auth first, so it's always available for login methods.
      this.initialIndexedDBStateKnown = false;
      // Initialize Firebase Auth
      const firebaseConfig = {
        apiKey: "AIzaSyCO8wUySlMYXELrX_zUD1qs9_LRV1nsTN8",
        authDomain: "cooksy-ea86d.firebaseapp.com",
        projectId: "cooksy-ea86d",
        storageBucket: "cooksy-ea86d.firebasestorage.app",
        messagingSenderId: "842242317068",
        appId: "1:842242317068:web:b882576c2e7629514e4729",
      };
      const fbapp = initializeApp(firebaseConfig);
      this.auth = getAuth(fbapp);

      // Get the Analytics
      this.$globalState.analytics = getAnalytics(fbapp);

      // Log event on page load
      logEvent(this.$globalState.analytics, "signin_init", {
        page_location: window.location.href,
        page_title: document.title,
      });

      // 2. Add a reader to capture responses from the server. This must be done
      // before any command is sent.
      if (this.reader == null) {
        this.reader = this.teoweb.addReader(function (gw, data) {
          switch (gw.command) {
            // Check token command from server
            case cmdCheckToken:
              that.hideProcessingOverlay(100);

              // Check error and do logout if error
              if (gw.err) {
                that.errMsg = gw.err;
                that.linkedProviders = [];
                that.doLogout();
                break;
              }

              // Parse response
              try {
                const response = JSON.parse(data);
                if (response.status === "ok") {
                  // Emit ready on success
                  console.debug(
                    "got " + cmdCheckToken + " answer: ok, providers:",
                    response.providers
                  );
                  that.linkedProviders = response.providers || [];
                  that.signedIn = true;
                  that.teoweb.token = response.status;
                  that.userMsg = "signed in";
                  that.$emit("ready", true);

                  // Send command to check Admin and Devel access on all running
                  // components runnibg at this moment
                  that.teoweb.sendCmd(cmdAccessDevel);
                  that.teoweb.sendCmd(cmdAccessAdmin);
                } else {
                  throw new Error(
                    response.message || "Unknown error from checktoken"
                  );
                }
                that.$globalState.isRegistered =
                  response.is_registered || false;
              } catch (e) {
                console.error(
                  "Error parsing checktoken response:",
                  e,
                  "Raw data:",
                  data
                );
                that.errMsg = "Не удалось обработать ответ от сервера.";
                that.doLogout();
              }

              break;
          }
        });
      }

      // 2a. Check for Telegram auth callback in URL hash (fragment).
      // This is the first step in our two-step redirect flow, as suggested.
      const hashParams = new URLSearchParams(window.location.hash.substring(1)); // Remove '#'
      const tgAuthResult = hashParams.get("tgAuthResult");

      if (tgAuthResult) {
        // As we cannot pass state through the Telegram redirect URL, we use
        // sessionStorage to retrieve the linking state.
        const linkToken = sessionStorage.getItem("cooksy_telegram_link_token");

        // Clean up sessionStorage immediately to prevent reuse.
        sessionStorage.removeItem("cooksy_telegram_link_token");

        const action = linkToken ? "linking" : "login";
        console.log(
          `SignIn: Found Telegram auth data in URL. Action: ${action}.`
        );
        // Clean the URL hash to prevent re-processing on refresh
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname + "#/" // Also cleans the query params
        );
        try {
          // The data is a Base64 encoded JSON string.
          const userData = JSON.parse(atob(tgAuthResult));
          // Construct query string from the parsed user data object.
          const queryParams = new URLSearchParams(userData);

          // If a link token is present, add it to the query parameters for the backend.
          if (linkToken) {
            queryParams.append("link_token", linkToken);
          }
          const queryString = queryParams.toString();

          this.isFirebaseProcessing = true; // Show spinner
          fetch(`https://cooksy.teonet.app/api/v1/auth.telegram?${queryString}`)
            .then((response) => {
              if (!response.ok) {
                // Try to get error message from backend response body
                return response.text().then((text) => {
                  throw new Error(
                    text || `Server responded with status: ${response.status}`
                  );
                });
              }
              return response.json();
            })
            .then((data) => {
              if (linkToken) {
                // This was a linking operation.
                if (data.status === "ok" && data.linked) {
                  this.successMsg = "Аккаунт Telegram успешно привязан!";
                  setTimeout(() => {
                    this.successMsg = "";
                  }, 5000);
                  // Re-validate the original session to get the updated list of linked providers.
                  this.sendCheckToken(this.TOKEN_TYPE_AUTOLOGIN, linkToken);
                } else {
                  throw new Error(
                    data.message || "Не удалось привязать аккаунт Telegram."
                  );
                }
              } else {
                // This was a login operation.
                if (data.status === "ok" && data.cooksy_app_uid) {
                  this.processOAuthToken(
                    data.cooksy_app_uid,
                    data.provider || "telegram"
                  );
                } else {
                  throw new Error(
                    data.message ||
                      "No cooksy_app_uid received from Telegram auth."
                  );
                }
              }
            })
            .catch((e) => {
              console.error("Failed to process Telegram auth data:", e);
              let friendlyError = e.message;
              if (friendlyError.includes("already linked")) {
                friendlyError =
                  "Этот аккаунт Telegram уже привязан к другому пользователю.";
              }
              this.errMsg = `Ошибка: ${friendlyError}`;
            })
            .finally(() => {
              if (linkToken) {
                this.hideProcessingOverlay(100);
              }
            });
        } catch (e) {
          console.error("Failed to parse Telegram auth data:", e);
          this.errMsg = "Ошибка аутентификации через Telegram.";
        }
        // Stop further auth checks, as Telegram login/linking is in progress.
        return;
      }

      // On the very first visit to the app on a new device,
      // perform an automatic anonymous login to lower the entry barrier
      // and immediately engage the user.
      const hasVisited = localStorage.getItem("cooksy_has_visited");
      if (!hasVisited) {
        console.log(
          "SignIn: First visit detected. Performing automatic anonymous login."
        );
        localStorage.setItem("cooksy_has_visited", "true");
        // The doAnonymousLogin method handles creating the token and sending it
        // to the server for verification.
        this.doAnonymousLogin();
        return; // Stop further auth checks, as anonymous login is in progress.
      }

      // 3. Check for different login methods in order of priority.

      // 3a. Check for an OAuth token in the URL from a redirect.
      const urlParams = new URLSearchParams(window.location.search);
      const oauthToken = urlParams.get("cooksy_app_uid");
      if (oauthToken) {
        const provider = urlParams.get("provider");
        if (provider === "link_result") {
          console.log(
            "SignIn: Yandex linking successful. Re-validating session."
          );
          this.isFirebaseProcessing = true;
          this.successMsg = "Аккаунт Яндекс успешно привязан!";
          setTimeout(() => {
            this.successMsg = "";
          }, 5000);
          // The oauthToken is the original session token.
          this.sendCheckToken(this.TOKEN_TYPE_AUTOLOGIN, oauthToken);
          // Clean URL
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname + "#/"
          );
        } else if (provider) {
          this.processOAuthToken(oauthToken, provider);
        }
        return; // Stop further auth checks, as we are handling a redirect.
      } else {
        // 3b. If not a redirect, check for an active session from localStorage
        const activeLogin = this.getActiveLogin() || "autologin"; // Default to autologin
        const tokens = this.getTokens();
        let token = tokens[activeLogin];

        if (activeLogin === "autologin" && !token) {
          console.log("SignIn: No auto-login token found, creating a new one.");
          token = crypto.randomUUID();
          tokens.autologin = token;
          this.saveTokens(tokens);
          this.setActiveLogin("autologin");
        }

        if (token) {
          this.isFirebaseProcessing = true;
          // The server only knows about 'auto-login' and 'firebase' types for checkToken
          // We send all our session tokens as 'auto-login' type.
          this.sendCheckToken(this.TOKEN_TYPE_AUTOLOGIN, token);
        }
      }

      // 4. Always proceed with Firebase's own session check.
      // Read from Firebase IndexedDB
      this.readFirebaseAuthIndexedDB(firebaseConfig.apiKey)
        .then((storedUser) => {
          console.log(
            "Stored user info from IndexedDB: ",
            storedUser,
            // Safely access uid
            storedUser && storedUser.value ? storedUser.value.uid : "N/A"
          );
          that.initialIndexedDBStateKnown = true;
          if (!storedUser) {
            // IndexedDB is empty or key not found. Assume no prior session for initial view.
            console.warn(
              "Initial IndexedDB check: No stored user found. Displaying login forms."
            );
            that.signedIn = false;
            that.user = null;
            that.isFirebaseProcessing = false; // Hide spinner immediately
            that.$emit("ready", false);
          } else {
            // IndexedDB has a user. Show spinner and let onAuthStateChanged verify.
            that.isFirebaseProcessing = true;
          }
        })
        .catch((error) => {
          // This catch block might still be useful for truly unexpected errors
          // from the readFirebaseAuthIndexedDB promise, though we aim to handle
          // common DB access issues by resolving with null.
          console.error(
            "Error reading IndexedDB during authInit. Assuming no prior session.",
            error
          );
          that.initialIndexedDBStateKnown = true;
          that.signedIn = false;
          that.user = null;
          that.isFirebaseProcessing = false; // Hide spinner immediately
          that.$emit("ready", false);
        })
        .finally(() => {
          // Unsubscribe from any previous listener
          if (this.authUnsubscribe) {
            this.authUnsubscribe();
            this.authUnsubscribe = null;
          }
          // Listen for auth state changes. This runs after IndexedDB check completes.
          this.authUnsubscribe = onAuthStateChanged(this.auth, (user) => {
            if (user) {
              // If an account linking process is active, ignore this auth change.
              // The linking method will handle the final state.
              if (this.isLinking) {
                console.log(
                  "onAuthStateChanged: Ignoring sign-in during linking process."
                );
                return;
              }

              // User is signed in according to Firebase.
              // If initialIndexedDBStateKnown was true and we decided user was signed out,
              // but Firebase now provides a user, it implies a new login or session recovery.
              // Ensure spinner is shown for token validation.
              if (!that.isFirebaseProcessing) {
                that.isFirebaseProcessing = true;
              }
              console.log("onAuthStateChanged: user signed in", user.uid);

              user
                .getIdToken(true)
                .then((idToken) => {
                  console.log(
                    "onAuthStateChanged: got token len:",
                    idToken.length
                  );
                  this.clearCheckTokenTimeout();
                  if (!user.emailVerified) {
                    console.log("onAuthStateChanged: email has not verified");
                    this.doLogout();
                    return;
                  }
                  // This is a Firebase session. Set it as active.
                  this.setActiveLogin("firebase");
                  this.sendCheckToken(this.TOKEN_TYPE_FIREBASE, idToken);
                  that.$emit("loggedin", true);
                  this.user = user;
                })
                .catch((tokenError) => {
                  console.error(
                    "onAuthStateChanged: Error getting ID token:",
                    tokenError
                  );
                  that.doLogout();
                });
            } else {
              // User is signed out according to Firebase.
              // If an account linking process is active, ignore this auth change.
              if (this.isLinking) {
                console.log(
                  "onAuthStateChanged: Ignoring sign-out during linking process."
                );
                return;
              }

              const activeLogin = that.getActiveLogin();
              // If we have an active cooksy session (yandex/telegram/autologin), we should not
              // immediately assume the user is logged out. We must wait for the
              // `checkToken` response from our server. By doing nothing here, we
              // allow the `checkToken` handler to be the single source of truth.
              if (
                activeLogin === "yandex" ||
                activeLogin === "telegram" ||
                activeLogin === "autologin"
              ) {
                console.log(
                  `onAuthStateChanged: Firebase user is signed out, but active login is '${activeLogin}'. Waiting for checkToken.`
                );
              } else {
                // No active cooksy session, so Firebase is the source of truth.
                // The user is truly signed out.
                this.signedIn = false;
                this.user = null;
                this.userMsg = "signed out";

                if (that.isFirebaseProcessing) {
                  this.hideProcessingOverlay(100);
                }
                this.$emit("ready", false);
              }
            }
          });
        });
    },

    /**
     * Read Firebase Auth data from IndexedDB.
     * @param {string} apiKey the Firebase API key
     * @returns {Promise<Object>} a promise that resolves to the data from IndexedDB
     */
    readFirebaseAuthIndexedDB(apiKey) {
      // Removed async keyword as it's not strictly necessary for this promise structure
      return new Promise((resolve) => {
        // Open the IndexedDB
        const request = indexedDB.open("firebaseLocalStorageDb");
        request.onerror = () => {
          // If there's an error opening IndexedDB (e.g., first time, browser issue),
          // treat it as "no stored user found" for our purposes.
          console.warn(
            "Error opening Firebase IndexedDB. Resolving with no stored user."
          );
          resolve(null); // Resolve with null instead of rejecting
        };
        request.onsuccess = (event) => {
          const db = event.target.result;
          // Check if the object store exists before attempting a transaction
          if (!db.objectStoreNames.contains("firebaseLocalStorage")) {
            console.warn(
              "Firebase IndexedDB store 'firebaseLocalStorage' not found. " +
                "Resolving with no stored user."
            );
            resolve(null); // Resolve with null, indicating no stored user found
            return;
          }
          // Proceed with transaction if store exists
          const transaction = db.transaction(
            ["firebaseLocalStorage"],
            "readonly"
          );
          const objectStore = transaction.objectStore("firebaseLocalStorage");
          const getRequest = objectStore.get(
            "firebase:authUser:" + apiKey + ":[DEFAULT]"
          );
          getRequest.onerror = () => {
            // If there's an error getting data from the object store,
            // also treat as "no stored user"
            console.warn(
              "Error getting data from Firebase IndexedDB store. Resolving with no stored user."
            );
            resolve(null); // Resolve with null
          };
          getRequest.onsuccess = () => {
            // Resolve the promise with the data from IndexedDB
            resolve(getRequest.result);
          };
        };
      });
    },

    /**
     * Hide the forms and send the "forms-cancelled" event.
     */
    doCancelForms() {
      this.shouldDisplayForms = false;
      this.$emit("forms-cancelled");
    },

    /**
     * Processes an OAuth token received from a redirect or fetch call.
     * @param {string} oauthToken The token received from the OAuth provider.
     * @param {string} provider The name of the provider (e.g., 'yandex', 'telegram', 'autologin').
     */
    processOAuthToken(oauthToken, provider) {
      console.log("SignIn: Processing OAuth token, provider:", provider);
      // Clean the URL to prevent re-processing on refresh.
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash
      );
      // Save the token as the new auto-login token.
      const tokens = this.getTokens();
      tokens[provider] = oauthToken;
      this.saveTokens(tokens);
      this.setActiveLogin(provider);
      this.isFirebaseProcessing = true;
      this.sendCheckToken(this.TOKEN_TYPE_AUTOLOGIN, oauthToken);
    },

    /**
     * Handle the anonymous login button click.
     *
     * If the user doesn't have an auto-login token yet, generate one and save it.
     * Then, send the token to the server to authenticate the user.
     */
    doAnonymousLogin() {
      this.triggerHapticFeedback("impact", "medium");
      const tokens = this.getTokens();
      let autoLoginToken = tokens.autologin;

      if (!autoLoginToken) {
        // Generate a new random token
        autoLoginToken = crypto.randomUUID();
        // Save the token to local storage
        tokens.autologin = autoLoginToken;
        this.saveTokens(tokens);
      }

      // Set the auto-login token as the active login
      this.setActiveLogin("autologin");

      console.log(
        "SignIn: User chose anonymous login. Using token:",
        autoLoginToken.substring(0, 8) + "..."
      );

      // Clear any previous error message
      this.errMsg = "";

      // Enable the auth processing overlay
      this.isFirebaseProcessing = true;

      // Send cmdCheckToken to server
      this.sendCheckToken(this.TOKEN_TYPE_AUTOLOGIN, autoLoginToken);

      // Emit the "loggedin" event with false as the second argument
      this.$emit("loggedin", false);
    },

    /**
     * Send the auth.checktoken command to the server with the given token and type.
     * @param {string} type The type of the token (e.g., 'firebase', 'autologin', 'yandex', 'telegram').
     * @param {string} token The token to send to the server.
     */
    sendCheckToken(type, token) {
      console.log("SignIn: send auth.checkToken");

      // Create payload for the auth.checktoken command
      const payload = JSON.stringify({
        type: type,
        token: token,
      });

      // Emit the "loggedin" event with false as the second argument to indicate
      // that the user is not yet logged in.
      this.$emit("loggedin", false);

      // Send the cmdCheckToken to the server when connected
      this.teoweb.whenConnected(() => {
        this.teoweb.sendCmd(cmdCheckToken, payload);
      });

      // Start a timeout for the cmdCheckToken response from the server.
      // If the server doesn't respond within 20 seconds, show an error message
      // to the user.
      const that = this;
      this.checkTokenTimeoutId = setTimeout(() => {
        console.warn(
          "Timeout waiting for cmdCheckToken response from backend."
        );
        if (that.isFirebaseProcessing) {
          that.errMsg =
            "Сервер не отвечает. Пожалуйста, " +
            "попробуйте обновить страницу или войти позже.";
          that.hideProcessingOverlay();
          that.$emit("ready", false);
        }
      }, 20000);
    },

    /**
     * Logs in to Firebase using an email and password.
     */
    doLogin() {
      console.log("start signIn with email");

      // Clear any previous error message
      this.errMsg = "";

      // Enable the auth processing overlay
      this.isFirebaseProcessing = true;

      // Sign in to Firebase
      signInWithEmailAndPassword(this.auth, this.emailLogin, this.passwordLogin)
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          console.log("signin:", user);

          // If the user is not verified, send them to the verify page
          if (!user.emailVerified) {
            this.authFormType = this.VERIFY_FORM;
          }
        })
        .catch((error) => {
          console.log("can't signin:", error.code, error.message);

          this.hideProcessingOverlay(0);
          this.$emit("ready", false);
          // Set the error message to the user
          this.errMsg = this.getFriendlyErrorMessage(error.code, error.message);
        });
    },

    /**
     * Logs out of Firebase and clears the auto-login token.
     */
    doLogout() {
      window.location.href = "#/";
      this.teoweb.token = null;
      this.signedIn = false;
      signOut(this.auth)
        .then(() => {
          // Sign-out successful.
          // onAuthStateChanged will handle UI updates (signedIn=false, emit auth-state:false)
          console.log("signOut successful");
        })
        .catch((error) => {
          // An error happened.
          console.log("signOut error:", error);
        })
        .finally(() => {
          // Clear this on any Firebase logout and auto-login token
          this.clearActiveLogin();
          this.user = null; // Clear firebase user object
          this.hideProcessingOverlay(0);
          this.$emit("ready", false);
        });
    },

    /**
     * Logs in to Firebase using a Google account.
     */
    doLoginGoogle() {
      console.log("start signIn with google");
      // Clear any previous error message
      this.errMsg = "";

      // Enable the auth processing overlay
      this.isFirebaseProcessing = true;

      // Create a Google Auth provider
      this.auth.languageCode = "ru";
      const provider = new GoogleAuthProvider();

      // Sign in to Firebase using the Google provider
      signInWithPopup(this.auth, provider)
        .then((userCredential) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          // const credential = GoogleAuthProvider.credentialFromResult(userCredential);
          // const token = credential.accessToken;
          // The signed-in user info.
          // const user = userCredential.user;
          // ...
          const user = userCredential.user;
          console.log("signin:", user);
        })
        .catch((error) => {
          // Handle Errors here.
          // const errorCode = error.code;
          // const errorMessage = error.message;
          // The email of the user's account used.
          // const email = error.customData.email;
          // The AuthCredential type that was used.
          // const credential = GoogleAuthProvider.credentialFromError(error);
          // ...
          if (error.code === "auth/popup-closed-by-user") {
            this.errMsg = ""; // Clear error message as per getFriendlyErrorMessage logic
            console.log("Google sign-in popup closed by user.");
          } else {
            console.log("can't signin:", error.code, error.message);
            this.errMsg = this.getFriendlyErrorMessage(
              error.code,
              error.message
            );
          }
          this.hideProcessingOverlay(0);
        });
    },

    /**
     * Logs in using a Yandex account.
     */
    async doLoginYandex(state = "") {
      console.log("start signIn with Yandex");
      this.errMsg = "";
      this.isFirebaseProcessing = true;

      const yandexClientId = "8ee2d9899dfc43a0a7bb285faaab50a4";

      // A random value could be used for CSRF protection in the future.
      let url =
        `https://oauth.yandex.ru/authorize?response_type=code&client_id=${yandexClientId}` +
        `&redirect_uri=https://cooksy.teonet.app/api/v1/auth.yandex` +
        `&force_confirm=true`; // This parameter forces Yandex to show the account selection/consent screen.

      if (state) {
        url += `&state=${encodeURIComponent(state)}`;
      }
      // Redirect the user to the Yandex auth page
      window.location.href = url;
    },

    /**
     * Initiates login with Telegram by redirecting to the OAuth page.
     */
    async doLoginTelegram() {
      console.log("start signIn with Telegram");
      this.errMsg = "";
      this.isFirebaseProcessing = true;

      const botId = "8306650456"; // Bot ID from your token

      // The return_to URL must be the frontend URL. Telegram will append
      // the auth data to the hash fragment (#tgAuthResult=...).
      const returnTo = window.location.href.split("#")[0];
      const origin = window.location.origin;
      const url = `https://oauth.telegram.org/auth?bot_id=${botId}&origin=${encodeURIComponent(
        origin
      )}&return_to=${encodeURIComponent(returnTo)}&request_access=write`;

      // Redirect the user to the Telegram auth page
      window.location.href = url;
    },

    /**
     * Creates a new user using Firebase Authentication
     * and sends an email verification message to the user.
     */
    doRegister() {
      console.log("start register");

      this.errMsg = "";
      if (
        this.emailReg === "" ||
        this.passwordReg === "" ||
        this.confirmReg === "" ||
        this.passwordReg !== this.confirmReg
      ) {
        this.emptyFields = true;
        if (this.passwordReg !== this.confirmReg) {
          this.errMsg = "Ошибка: Пароли не совпадают";
        }
        return;
      }

      // Enable the auth processing overlay
      this.isFirebaseProcessing = true;

      // Sign up to Firebase
      createUserWithEmailAndPassword(this.auth, this.emailReg, this.passwordReg)
        .then((userCredential) => {
          console.log("registering success", userCredential.user);
          // Send an email verification message to the user
          sendEmailVerification(userCredential.user)
            .then(() => {
              // Email verification sent!
              console.log(
                "Письмо для подтверждения отправлено! Проверьте ваш почтовый ящик"
              );
              // After registration and verification email sent, typically move
              // to a verify state. onAuthStateChanged might not fire immediately
              // for a new user until page reload or explicit sign-in.
              this.authFormType = this.VERIFY_FORM;
            })
            .catch((error) => {
              this.hideProcessingOverlay();
              console.log(
                "can't send email verification:",
                error.code,
                error.message
              );
              this.errMsg =
                "Не удалось отправить письмо для подтверждения: " +
                error.message;
              this.authFormType = this.VERIFY_FORM;
              this.hideProcessingOverlay(100);
            });
        })
        .catch((error) => {
          this.hideProcessingOverlay();
          console.log("can't registering:", error.code, error.message);
          this.errMsg = this.getFriendlyErrorMessage(error.code, error.message);
        });
    },

    /**
     * Resets the user's password by sending an email with a link to the Firebase
     * Authentication password reset page.
     *
     * @return {void}
     */
    doResetPassword() {
      console.log("start reset password");

      // Enable the auth processing overlay
      this.isFirebaseProcessing = true;
      this.errMsg = "";

      // Send password reset email
      sendPasswordResetEmail(this.auth, this.emailReset)
        .then(() => {
          // Password reset email sent!
          console.log("Письмо для сброса пароля отправлено");
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(
            "can't send reset password email, error:",
            errorCode,
            errorMessage
          );
          this.errMsg =
            "Не удалось отправить письмо для сброса пароля: " +
            this.getFriendlyErrorMessage(error.code, error.message);
        })
        .finally(() => {
          this.hideProcessingOverlay();
        });
    },

    /**
     * Toggles the type of the password input field between "password" and "text".
     * This is used to show or hide the password input.
     *
     * @return {void}
     */
    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },

    // --- Account Linking Methods ---

    /**
     * Prepares for an account linking operation.
     * It gets the current session token and handles provider-specific state storage.
     * @param {string} providerName The name of the provider to link ('yandex', 'telegram').
     * @returns {string|null} The link token if a session exists, otherwise null.
     */
    prepareLinkWithProvider(providerName) {
      console.log(`Preparing to link a new provider: ${providerName}`);
      this.errMsg = "";
      this.successMsg = "";

      const activeLogin = this.getActiveLogin();
      const tokens = this.getTokens();
      const linkToken = tokens[activeLogin];

      if (!linkToken) {
        this.errMsg =
          "Текущая сессия не найдена. Невозможно привязать аккаунт.";
        return null;
      }

      if (providerName === "telegram") {
        // Store linking info in sessionStorage before redirecting, as Telegram
        // does not support the 'state' parameter.
        sessionStorage.setItem("cooksy_telegram_link_token", linkToken);
      }

      return linkToken;
    },

    async linkWithGoogle() {
      console.log("start linking with Google");
      this.errMsg = "";
      this.successMsg = "";
      this.isFirebaseProcessing = true;
      this.isLinking = true; // Set linking flag

      const originalLoginType = this.getActiveLogin();
      const originalToken = this.getTokens()[originalLoginType];

      const provider = new GoogleAuthProvider();
      try {
        const userCredential = await signInWithPopup(this.auth, provider);
        const idToken = await userCredential.user.getIdToken();
        const payload = JSON.stringify({ type: "firebase", token: idToken });
        const responseRaw = await this.sendCmd("auth.link", payload);
        const response = JSON.parse(responseRaw);

        if (response.status !== "ok") {
          throw new Error(response.message || "Link command failed on server");
        }

        this.successMsg = "Аккаунт Google успешно привязан!";
        setTimeout(() => {
          this.successMsg = "";
        }, 5000);

        if (getAuth().currentUser) {
          console.log(
            "Link successful. Signing out of temporary Firebase session to restore original user state."
          );
          await signOut(this.auth);
        }
      } catch (error) {
        // New error handling
        if (error.code) {
          // Firebase client-side errors (e.g., popup closed)
          this.errMsg = this.getFriendlyErrorMessage(error.code, error.message);
        } else {
          // Errors from our backend
          let friendlyError = String(error);
          if (friendlyError.includes("already linked to another user")) {
            friendlyError =
              "Этот аккаунт уже привязан к другому пользователю. Невозможно выполнить привязку.";
          }
          this.errMsg = friendlyError;
        }
        this.successMsg = "";

        // IMPORTANT: If the linking process fails, sign out of the temporary
        // Firebase session to prevent being stuck in the new account.
        if (getAuth().currentUser) {
          console.log(
            "Link failed. Signing out of temporary Firebase session."
          );
          await signOut(this.auth);
        }
      } finally {
        this.isLinking = false; // Reset linking flag
        this.hideProcessingOverlay(100);

        // After any link attempt (success or fail), if we are logged out of Firebase,
        // re-validate the original session to restore the user's state and get
        // the updated list of linked providers.
        if (!getAuth().currentUser && originalToken) {
          console.log("Restoring original session after link operation.");
          this.sendCheckToken(this.TOKEN_TYPE_AUTOLOGIN, originalToken);
        }
      }
    },

    async linkWithYandex() {
      const linkToken = this.prepareLinkWithProvider("yandex");
      if (!linkToken) {
        return;
      }
      // We pass the current session token in the 'state' parameter.
      // The backend will use this to identify the user to link the Yandex account to.
      this.doLoginYandex(linkToken);
    },

    async linkWithTelegram() {
      const linkToken = this.prepareLinkWithProvider("telegram");
      if (!linkToken) {
        return;
      }
      // The doLoginTelegram method contains the redirection logic,
      // which is common for both login and linking.
      this.doLoginTelegram();
    },

    /**
     * Send the auth.link command to the server with the given type and token.
     * The current session token is used for authentication.
     * @param {string} type The type of the token (e.g., 'firebase', 'yandex', 'telegram').
     * @param {string} token The token to link to the current user account.
     */
    async sendLinkCommand(type, token) {
      const payload = JSON.stringify({
        type: type,
        token: token,
      });
      // This command must be authenticated by the current session token,
      // which teoweb sends automatically.
      await this.sendCmd("auth.link", payload);
      console.log(`Successfully sent link command for type: ${type}`);
    },

    /**
     * Converts a hex color string to an RGB string "r, g, b".
     * @param {string} hex - The hex color string (e.g., "#RRGGBB").
     * @returns {string} The RGB values as a comma-separated string.
     */
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
            result[3],
            16
          )}`
        : null;
    },

    triggerHapticFeedback(type, style) {
      if (this.tgHapticFeedback) {
        switch (type) {
          case "impact":
            // 'light', 'medium', 'heavy'
            this.tgHapticFeedback.impactOccurred(style);
            break;
          case "notification":
            // 'error', 'success', 'warning'
            this.tgHapticFeedback.notificationOccurred(style);
            break;
          case "selection":
            this.tgHapticFeedback.selectionChanged();
            break;
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  line-height: 1rem;
}

.gate-overlay {
  position: absolute; /* Fixed position to cover the whole viewport */ /* fixed; /* Fixed position to cover the whole viewport */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1040;
  color: white;
}

.gate-overlay-content {
  text-align: center;
  top: 100px;
  position: absolute;
}

.login-signout-container {
  /* position: absolute; */
  padding-left: 5px;
  margin-right: 0;
  /* top: 20px; */
}
.login-signout-container img {
  height: 25px;
  border: none;
  margin: 0;
  padding: 0;
}

.card {
  padding: 20px;
}

.container {
  max-width: 500px;
  min-width: 330px;
}

.btn-outline-info {
  color: var(--bs-purple);
  border-color: var(--bs-purple);
}
.btn-outline-info:hover {
  background-color: var(--bs-purple);
  border-color: var(--bs-purple);
  color: white;
}

.login-page {
  margin-top: -112px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;

  /* Forms container will now be on top of gate-overlay */
  .container {
    position: relative;
    top: auto;
    z-index: 1041;
  }

  h2 {
    margin-bottom: 25px;
  }
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

.card.errmsg {
  color: red;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}

.firebase-processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10500;
  color: white;
}

.fixed-top-alert {
  position: fixed;
  top: 70px; /* Adjust based on your navbar height */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1050; /* Ensure it's above other content */
  width: 90%;
  max-width: 600px;
}
</style>
